/**
 * Delays a heavy task.
 * This workaround MAY help to improve INP value of WebVitals.
 *
 * @param {Function} taskFn the function of the heavy task to delay.
 */
export const delayHeavyTask = taskFn => setTimeout(taskFn, 0);

/**
 * Gives the browser a chance to paint before running the task.
 * This function follows the pattern described here
 * https://web.dev/articles/optimize-inp#yield_to_allow_rendering_work_to_occur_sooner
 *
 * @param {Function} task the task to delay.
 * @returns {Function} a function to cancel the scheduled task.
 */
export function scheduleAfterPaint(task) {
  let timer;
  let frame;
  if (document.visibilityState === 'hidden') {
    timer = setTimeout(task, 0);
  } else {
    frame = requestAnimationFrame(() => {
      timer = setTimeout(task, 0);
    });
  }

  return () => {
    cancelAnimationFrame(frame);
    clearTimeout(timer);
  };
}
